import { render, staticRenderFns } from "./gantt-chart-add.vue?vue&type=template&id=08cf00a9&scoped=true&"
import script from "./gantt-chart-add.vue?vue&type=script&lang=js&"
export * from "./gantt-chart-add.vue?vue&type=script&lang=js&"
import style0 from "./gantt-chart-add.vue?vue&type=style&index=0&id=08cf00a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf00a9",
  null
  
)

export default component.exports